import { render, staticRenderFns } from "./BlocoInserirDadosManual.vue?vue&type=template&id=6074e24e&lang=pug"
import script from "./BlocoInserirDadosManual.vue?vue&type=script&lang=js"
export * from "./BlocoInserirDadosManual.vue?vue&type=script&lang=js"
import style0 from "./BlocoInserirDadosManual.vue?vue&type=style&index=0&id=6074e24e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports